import { getCurrentEnvironment, getPageName, getPageType } from './helperFunctions.js';

const env_snowplow_collector_url = getCurrentEnvironment() == 'prod' ? 'https://nl-rtl-prod1.collector.snplow.net' : 'https://nl-rtl-prod1.mini.snplow.net' ;

export const globalVars = {
    env: getCurrentEnvironment(),
    snowplow_collector_url : env_snowplow_collector_url,
    app_id: 'Videoland',
    platform: 'videolandweb',
    language: 'nl-NL',
    page_name: getPageName(),
    page_type: getPageType(),
}